import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import SearchByReferenceForm from "@components/dynamic/SearchByReferenceForm";

const SearchByReferenceReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Buscar Documento por Referencia"
      backUrl="/user/dashboard-accounting"
    >
      <SearchByReferenceForm />
    </PageContainer >
  );
}

export default SearchByReferenceReport;
